import { controls, currencyToNumber, grouped, where_pending } from "../../controls";

const rpad131 = {
  label: "Consolidated Report",
  starting: true,
  url: "rp101m",
  pageLabel: "Consolidated Report",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.displayText({ tab: "filter", label: "Inspection Season", star: true }),
    ...controls.autoComplete({ tab: "filter", name: "inspection_master_code", width: "col-sm-2", controlType: "InspectionMaster" }),
    ...controls.displayText({ tab: "filter", label: "" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Consolidated Report",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pivotable: true,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    extraRows: {
      location: "top",
      fields: ["observation_type"],
      subtotals: {
        by: "branch_display",
        displayIn: "observation_type",
        subtotals: {
          by: "insgroup",
          displayIn: "observation_type",
        }
      }
      // grandtotal: { type: "fixed", displayIn: "pacs_name", val: "Grand Total", count: true },
    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      // {
      //   Header: "Branch",
      //   accessor: "branch_display",
      //   rwidth: "*"
      // },
      {
        Header: "Observation",
        accessor: "observation_type"
      },
      {
        Header: "Inspection Date",
        accessor: "date",
        type: "date"
      },
      {
        Header: "Status",
        accessor: "inspection_status"
      },
      {
        Header: "Pending At",
        accessor: "pending_at",
        formula: [{
          f: 'runFormula', calcType: where_pending, inputs: [], resultVar: 'total'
        }],
      },
      {
        Header: "Remark",
        accessor: "remark"
      },
      {
        Header: "Complete By",
        accessor: "complete_by",
        type: "date"
      }
    ]
  }
};

export default rpad131;